export const Models: string[] = [
    "2D plane",
    "airplane.ply",
    "ant.ply",
    "apple.ply",
    "balance.ply",
    "beethoven.ply",
    "big_atc.ply",
    "big_dodge.ply",
    "big_porsche.ply",
    "big_spider.ply",
    "bunny",
    "canstick.ply",
    "chopper.ply",
    "cow.ply",
    //"cube.ply",
    "dart.ply",
    "dodecahedron.ply",
    "dolphins.ply",
    "egret.ply",
    "f16.ply",
    "footbones.ply",
    "fracttree.ply",
    "galleon.ply",
    "hammerhead.ply",
    "helix.ply",
    "hind.ply",
    "humanoid_tri",
    "icosahedron.ply",
    "kerolamp.ply",
    "ketchup.ply",
    "mug.ply",
    "octahedron.ply",
    "part.ply",
    "pickup_big.ply",
    "pump.ply",
    "pyramid.ply",
    "sandal.ply",
    "saratoga.ply",
    "scissors.ply",
    "shark.ply",
    "skull.ply",
    "sphere.ply",
    "steeringweel.ply",
    "stratocaster.ply",
    "street_lamp.ply",
    "symphysis.ply",
    "teapot.ply",
    "tennis_shoe.ply",
    "tetrahedron.ply",
    "tommygun.ply",
    "trashcan.ply",
    "turbine.ply",
    "urn2.ply",
    "walkman.ply",
    "weathervane.ply"];